import { CxEvent } from '@spartacus/core';

export class GonvarriProductDetailsPageEvent extends CxEvent {
  static override readonly type = 'GonvarriProductDetailsPageEvent';
  product_category?: string;
  product_id?: string;
  product_name?: string;
  product_price?: number;
  user_id?: string;
  user_email?: string;
  product_stock?: string;
}


export class GonvarriSearchPageResultsEvent extends CxEvent {
  static override readonly type = 'GonvarriSearchPageResultsEvent';
  user_id?: string;
  user_email?: string;
  search_text?: string;
}

